// extracted by mini-css-extract-plugin
export default {"UserFollowPageContainer":"UserFollowPage_UserFollowPageContainer__KcfoX"};